module.exports = __webpack_public_path__ + "img/sdg12_jp.05c53356.png";